export enum Scope {
  PROFILE = 'profile',
  EMAIL = 'email',
  STORAGE = 'https://www.googleapis.com/auth/devstorage.read_write',
  OPENID = 'openid',
  DRIVE_ADMIN_LABELS ='https://www.googleapis.com/auth/drive.admin.labels'
}
